$("#different-delivery-address").on("change", function () {
    // Toggle visibility of .delivery-address-container
    $("#delivery-address-container").toggle();
});

// KvK verplicht voor Nederland, btw-nummer verplicht daarbuiten (FEKO-1340)
function toggleRequiredByCountry() {
    const isNl = $("#country").val() === "NL";
    $("#kvk-required").toggle(isNl);
    $("#vatnumber-required").toggle(!isNl);
}
$("#country").on("change", toggleRequiredByCountry);
toggleRequiredByCountry();
